module.exports = __webpack_public_path__ + "media/assets/icons/zidosya_icon-a697cb3952e3ddc560bd9982e5777b2f.svg";